module.exports = __webpack_public_path__ + "img/userA08.ef98fd27.jpg";